import { z } from 'zod/v4';

export interface IAddress {
  id?: string;
  firstName: string;
  lastName: string;
  street: string;
  houseNumber: string;
  city: string;
  country: string;
  additional?: string;
  postCode: string;
}

export const ADDRESS_SCHEMA: z.ZodType<IAddress> = z.object({
  id: z.string().optional(),
  firstName: z.string(),
  lastName: z.string(),
  street: z.string(),
  houseNumber: z.string(),
  city: z.string(),
  country: z.string(),
  additional: z.string().optional(),
  postCode: z.string(),
});
